"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPerformanceScpiFonctionCorporation = void 0;
exports.ESubPerformanceScpiFonctionCorporation = {
    dividendeDistribue: "dividendeDistribue",
    evolutionPrixPart: "evolutionPrixPart",
    desDeux: "desDeux",
};
